<template>
  <div>
    <Header></Header>
    <div class="bg">
      <div class="topic" v-for="(list,index) in lists" :key="index" @click="got_details(list.id)">
        <div class="topic-left">
          <img class="left-img" :src="list.avatar" alt />
          <div class="topic-left-right">
            <div class="name">{{list.nickname}}</div>
            <img src="../../assets/img/jiangs.png" alt />
            <span class="chenghu">{{list.the_title}}</span>
            <div class="jianjie">{{list.intro}}</div>
          </div>
        </div>
        <img v-for="(data,index) in list.data" :key="index" class="topic-img" :src="data.image" alt />
        <!-- <img class="topic-img" src="../../assets/img/0.jpg" alt />
        <img class="topic-img" src="../../assets/img/0.jpg" alt /> -->
      </div>
    </div>
    <div style="margin:0 auto;width:800px;text-align:center;margin-bottom:14px;">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout=" prev, pager, next"
        :total="totalNum"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import Header from "../header";
import Footer from "../footer";
export default {
  name: "",
  data() {
    return {
      lists: [],
      currentPage: 1, //默认显示第一页
      pageSize: 8, //默认每页显示条
      totalNum: 0 //总页数
    };
  },
  methods: {
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val; //动态改变
      this.teacher_list();
    },
    // 科研团队
    async teacher_list() {
      await this.$service.home
        .teacher_list({ page: this.currentPage, page_count: this.pageSize,pc:1 })
        .then(res => {
          console.log(res.data);
          if (res.data.code == 200) {
            this.lists = res.data.content.list;
            // 向上取整数
            var totalNum = Math.ceil(res.data.content.count);
            this.totalNum = totalNum;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    got_details(id) {
      console.log(id);
      this.$router.push({
        path: "topic_details",
        query: {
          id: id
        }
      });
    }
  },
  components: {
    Header,
    Footer
  },
  mounted() {
    this.teacher_list();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
  margin-top: 20px;
}
.topic {
  width: 1200px;
  height: 200px;
  background: rgba(255, 255, 255, 1);
  margin: 0 auto;
  display: flex;
  /* justify-content: space-around; */
  align-items: center;
  border-bottom: 1px solid #ededed;
}
.topic .topic-left {
  width: 355px;
  height: 160px;
  display: flex;
  margin:0 20px 0 20px;
}
.topic .topic-left .left-img {
  width: 126px;
  height: 160px;
  border-radius: 6px;
}
.topic .topic-left .topic-left-right {
  margin-left: 10px;
  width: 220px;
}
.topic .topic-left .topic-left-right .name {
  font-size: 20px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 28px;
  letter-spacing: 1px;
  margin-bottom: 6px;
}
.topic .topic-left .topic-left-right .chenghu {
  font-size: 14px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 20px;
}
.topic .topic-left .topic-left-right .jianjie {
  font-size: 14px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
  margin-top: 26px;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
}
.topic .topic-img {
  width: 240px;
  height: 160px;
    margin-right:20px;
}
</style>



// WEBPACK FOOTER //
// src/components/jytd/topic.vue